
// * 获取facebook买量全天数据

import { useForm } from "antd/es/form/Form";
import { useTypedDispatch, useTypedSelector } from "../../../hooks/store.hook";
import { _message } from "../../../components/message";
import { MODAL_TYPE } from "../../../store/reducers/modalSlice";
import { Button, DatePicker, Flex, Form, Modal, Select } from "antd";
import dayjs from 'dayjs';
import { getSitesDataForFacebook } from '@/service/adjustRoi.service';
import { pullFacebookData, queryFacebookPurchase } from "../service";
import { useMemo, useEffect, useState } from "react";
import { _setAlert } from "../../../components/alert";

export default function FacebookModal () {
    const { type, status } = useTypedSelector(state => state.modalReducer);
    const dispatch = useTypedDispatch();
    const [form] = useForm();
    const [disabled , setDisabled] = useState(false);
    const [sites, setSites] = useState([]);

    const onOk = async () => {
        try{
            await form.validateFields();
            const values = form.getFieldsValue();
            values.queryDate = (values.queryDate).format('YYYY-MM-DD');
            try{
                const result = await pullFacebookData(values);
                // _message.success(result.msg || '获取成功');
                _setAlert({ type: 'success', message: 'facebook同步数据:' + (result.msg || '同步成功') });
            }catch(err: any){
                _setAlert({ type: 'error', message: 'facebook同步数据:' + (err.msg || '同步失败') });
                // _message.error(err.msg || '获取失败');
            }
        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    _message.error(v.errors.join(','))
                })
            }
        }
    }

    const onGetResult = async () => {
        try{
            await form.validateFields();
            const values = form.getFieldsValue();
            values.queryDate = (values.queryDate).format('YYYY-MM-DD');
            try{
                const result = await queryFacebookPurchase(values);
                _message.success(result.msg || '获取成功');
            }catch(err: any){
                // _message.error(err.msg || '获取失败');
            }
            // dispatch({ type: "modal/hideModal" });
        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    _message.error(v.errors.join(','))
                })
            }
        }
    }
 
    const onCancel = () => {
        dispatch({ type: "modal/hideModal"})
    }

    const filter = (inputValue: string, path: any) => {
        const isArray = Array.isArray(path);
        switch (isArray) {
            case true:
                const inputs = inputValue.split('/');
                return inputs.length > 1  ? inputs.every(input => path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(input.toLowerCase()) > -1)) : path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            default:
                return path.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        }
    }

    const siteOptions = useMemo(() => {
        if(sites.length){
            return sites.map((item: {id:Number, site: string}) => ({ label: item.site, value: item.site }))?.sort((a, b) => a?.label?.localeCompare(b?.label));
        }
        return [];
    }, [sites])

    const initSitesOptions = async () => {
        try {
            const { code, data } = await getSitesDataForFacebook();
            if (code === 200) {
                setSites(data);
            }
        } catch (error) {
            _message.error('系统错误');
        }
    };

    useEffect(() => {
        initSitesOptions();
    }, []);

    return <Modal title="获取买量数据" forceRender onOk={onOk} open={status && type === MODAL_TYPE.facebook} cancelText={'关闭'} onCancel={onCancel} footer={
        <div style={{ display: 'flex', gap: '10px' }}>
            <Button type="primary" disabled={disabled}  onClick={onOk} >同步数据</Button>
            {/* <Button type="primary" onClick={onGetResult}>查看结果</Button> */}
            <Button onClick={onCancel}>关闭</Button>
        </div>
    } >
        <Form form={form} layout="inline" initialValues={{ queryDate: dayjs() }}>
            <Flex vertical={true} gap="large">
                <Form.Item name='sites' label="站点" rules={[{ required: true, message: '站点不能为空' }]}>
                    <Select mode="multiple" listHeight={450} allowClear={true} showSearch={true} filterOption={filter} placeholder="站点" style={{ minWidth: 260, marginLeft: '2ch' }} options={siteOptions}></Select>
                </Form.Item>
                <Form.Item name="queryDate" label="日期" required={true} rules={[{ required: true, message: '日期不能为空' }]}>
                    <DatePicker style={{ minWidth: 260, marginLeft: '2ch' }}></DatePicker>
                </Form.Item>
            </Flex>
        </Form>
    </Modal>
}
